export default{
    route:{
        home:'Home', 
        bonusList:'Prize Money',   
        picture:'Photo',
        players:'Players',
        schedule:'Tournaments',
    },
   
}


// WEBPACK FOOTER //
// ./src/lang/en.js